import AbstractService from './AbstractService';
import store from '../store/store';
import Dotize from './Dotize';

export default class TaskService extends AbstractService {
  url(url) {
    return `/task${url}`;
  }

  async createTask(model) {
    const data = await this.http.post(this.url('/createTask'), model);
    return data;
  }

  async personalTasks(reference, type) {
    const params = this.dateRange(type);
    console.log(type);
    const tasks = await this.http.get(this.url(`/personalTasks/${reference}`), { params });
    return tasks;
  }

  async managerCreatedTasks(query, reference, type) {
    const params = await this.dateRange(type, reference);
    const tasks = await this.http.get(this.url(query), { params });
    return tasks;
  }

  dateRange(type, reference) {
    const params = {};
    if (type) {
      params.from = new Date().toLocaleDateString();
      params.to = type == 'week' ? this.getTo(8) : this.getTo(1);
    }
    if (reference) {
      params.reference = reference;
    }
    return params;
  }

  getTo(day) {
    const d = new Date();
    d.setDate(d.getDate() + day);
    return d.toLocaleDateString();
  }

  async dateRangeTasks(query, type) {
    const params = {
      from: new Date().toLocaleDateString(),
      to: type[0] == 'week' ? this.getTo(8) : this.getTo(1),
    };
    const tasks = await this.http.get(this.url(query), { params });
    return tasks;
  }

  async updateTask(task) {
  	const data = await this.http.put(this.url(`/updateTask/${task.reference}`), task);
  	return data;
  }

  async deleteTask(reference) {
    const data = await this.http.delete(this.url(`/deleteTask/${reference}`));
    return data;
  }

  async saveComment(comment) {
    const data = await this.http.post(this.url('/saveComments'), comment);
    return data;
  }

  async uploadFile(data) {
    const response = await this.http.post('/uploadFiles', data);
    if (response.status == 200) {
      const data = await this.http.post(this.url('/uploadFile'), response.data);
      return data;
    }
  }

  async readFile(model) {
    const data = await this.http.post(this.url('/readFile'), model);
    return data;
  }

  async deleteFile(name) {
    const model = {
      name,
    };
    const data = await this.http.post(this.url('/deleteFile'), model);
    return data;
  }

  async updateComment(reference, model) {
    const data = await this.http.put(this.url(`/updateComment/${reference}`), model);
    return data;
  }

  async deleteComment(reference) {
    const data = await this.http.delete(this.url(`/deleteComment/${reference}`));
    return data;
  }
}
